import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DefaultButton } from 'components/button/DefaultButton';
import { PasswordInput } from 'components/forms/PasswordInput';
import { TextInput } from 'components/forms/TextInput';
import { ValidatableLabel } from 'components/forms/ValidatableLabel';
import { ValidationSummary } from 'components/forms/ValidationSummary';
import {
    BackButton,
    LoginFooter,
    LoginForm,
    ResetPasswordButton,
} from 'pages/Login/Login';
import * as React from 'react';
import {
    Control,
    Controller,
    FieldError,
    RegisterOptions,
    UseFormRegister,
} from 'react-hook-form';

const passwordRules: RegisterOptions = {
    required: 'Please enter your password.',
};

export type PasswordScreenProps = {
    email: string;
    register: UseFormRegister<LoginForm>;
    control: Control<LoginForm>;
    passwordErrors: FieldError | undefined;
    onLogin: () => void;
    onSubmit: (event: React.FormEvent) => void;
    onBack: () => void;
    onResetPassword: () => void;
    errorMessage?: string;
    onChange?: () => void;
    actionable: boolean;
};

export function PasswordScreen({
    email,
    control,
    register,
    passwordErrors,
    onLogin,
    onSubmit,
    onResetPassword,
    onBack,
    errorMessage,
    onChange,
    actionable,
}: PasswordScreenProps) {
    register('password', passwordRules);

    return (
        <form onSubmit={onSubmit}>
            {/* The hidden input allows the email/form state to get carried across renders */}
            <TextInput type="hidden" value={email} {...register('email')} />
            <BackButton type="button" className="mb-20" onClick={onBack}>
                <FontAwesomeIcon className="text-blue-5 mr-10" icon={faArrowLeft} />
                <strong style={{ overflow: 'hidden', wordBreak: 'break-word' }}>
                    {email}
                </strong>
            </BackButton>
            {errorMessage && (
                <ValidationSummary className="mb-20">{errorMessage}</ValidationSummary>
            )}
            <ValidatableLabel label="Password" className="mb-10" error={passwordErrors}>
                <Controller
                    control={control}
                    name="password"
                    rules={passwordRules}
                    render={({ field: { value, onChange: fieldOnChange, onBlur } }) => (
                        <PasswordInput
                            className="my-5"
                            placeholder="Enter your password"
                            autofocus
                            invalid={passwordErrors !== undefined}
                            name="password"
                            value={value}
                            onChange={(event) => {
                                onChange?.();
                                fieldOnChange(event);
                            }}
                            onBlur={onBlur}
                        />
                    )}
                />
            </ValidatableLabel>
            <LoginFooter>
                <ResetPasswordButton
                    type="button"
                    onClick={onResetPassword}
                    aria-label="Reset Password"
                >
                    Reset Password
                </ResetPasswordButton>
                <DefaultButton
                    type="button"
                    onClick={onLogin}
                    disabled={!actionable}
                    aria-label="Log In"
                >
                    Log In
                </DefaultButton>
            </LoginFooter>
        </form>
    );
}
